import { memo } from 'react';
import bones from '../../../assets/img/bones.png'
import bonesWebp from '../../../assets/img/bones.webp'
import ImgWithFallback from '../../ui/ImgWithFallback';

interface IUserCharactersDeadProps {
    maxHp: number
}

const UserCharactersDead = ({ maxHp }: IUserCharactersDeadProps) => {

    return (
        <>
            <ImgWithFallback
                src={bonesWebp}
                fallbackSrc={bones}
                classNames={'player__content-img isDead'} />
            <div className="player__content-hp">
                <span style={{ width: `0%` }}></span>
                <p>0 / {maxHp}</p>
            </div>
        </>
    );
};

export default memo(UserCharactersDead);